import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Holds a user whose password must be changed on My Account, on every navigation.
 *
 * AuthService only redirects when it fetches the profile from the server - sign-in and a fresh page
 * load - so without this a flagged user could leave My Account and use the whole app in an already
 * loaded tab, and only links that open a new tab (the tank grid's tank name) sent them back.
 * Changing the password re-reads the profile, which clears the flag and releases the hold.
 */
export const MustChangePasswordGuard: CanActivateChildFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Same test as the my-account route matcher and UserDetailsGuard; it also covers /:theme/my-account.
  if (state.url.toLowerCase().includes('my-account')) return true;

  return authService.getUserInformation().pipe(
    take(1),
    map((userInfo) =>
      userInfo?.mustChangePassword ? router.createUrlTree(['/my-account']) : true,
    ),
  );
};
